import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import LabeledSlider from "../../../../components/Common/LabeledSlider/LabeledSlider";
import { CheckinAndMaxAdvancedBooking, MetaData } from "../../../Login/typings/login.types";
import { BookingType } from "../../../Booking-Form/typings/booking-inputs";
import { updateCheckInSettings } from "../../functions/company-card.component.functions";
import { MaximumAdvancedBookingPerTypeWeekdaySelect } from "../../UserManagement/company-card-maximumAdvancedBooking-perType-weekdaySelect.partial";

type MaximumAdvancedBookingSettingsProps = {
  bookingType: BookingType;
  sliderLabelType: string;
  setting: CheckinAndMaxAdvancedBooking;
  newValues?: MetaData;
  setNewSetting: Dispatch<SetStateAction<CheckinAndMaxAdvancedBooking>>;
  setNewValues?: Dispatch<SetStateAction<MetaData>>;
  "data-testid": string;
};

export function MaximumAdvancedBookingSettings({
  bookingType,
  sliderLabelType,
  setting,
  newValues,
  setNewSetting,
  setNewValues,
  "data-testid": dataTestId
}: Readonly<MaximumAdvancedBookingSettingsProps>) {
  const { t } = useTranslation();

  return (
    <>
      <LabeledSlider
        paddingRight="10px"
        marginRight="5px"
        value={setting.maxWeeksInAdvance || 6}
        label={t("_companyMaximumAdvancedBookingLabel", {
          type: t(sliderLabelType)
        })}
        onChange={(e, v) => {
          /* istanbul ignore next */
          setNewSetting(prev => ({ ...prev, maxWeeksInAdvance: v as number }));
          /* istanbul ignore next */
          setNewValues?.(prevState =>
            updateCheckInSettings(prevState, bookingType, {
              ...setting,
              maxWeeksInAdvance: v as number
            })
          );
        }}
        min={1}
        max={52}
        step={1}
        data-testid={dataTestId}
        sliderMarginleft="10px"
      />

      {/* istanbul ignore next */}
      <MaximumAdvancedBookingPerTypeWeekdaySelect
        data-testid={`${dataTestId}-weekday-select-box`}
        setting={setting}
        newValues={newValues}
        handleWeekdaySelect={newVal => {
          /* istanbul ignore next */
          setNewSetting(prev => ({ ...prev, weekday: newVal }));
        }}
        handleTimeSelect={newVal => {
          /* istanbul ignore next */
          setNewSetting(prev => ({ ...prev, time: newVal }));
        }}
        handleAllowDaysSelect={newVal => {
          /* istanbul ignore next */
          setNewSetting(prev => ({ ...prev, allowedBookingDaysInAdvance: newVal }));
        }}
      />
    </>
  );
}
